import ScrollToTop from "react-scroll-to-top";

export const ScrollTop = () => {
  return (
    <ScrollToTop
      smooth
      color="white"
      viewBox="0 0 24 24"
      svgPath="M17.657 15.657a1 1 0 0 1-.707-.293L12 10.414l-4.95 4.95a1 1 0 0 1-1.414-1.414l5.657-5.657a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-.707 1.707z"
      className="p-1.5 !bg-nutricare-green hover:!bg-nutricare-orange transition"
    />
  );
};
